<template>
  <el-dropdown @command="open">
    <el-button :type="buttonType">{{ buttonText }}<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="toutiao_template">巨量引擎2.0</el-dropdown-item>
      <el-dropdown-item command="toutiaov3_template">巨量智擎版</el-dropdown-item>
      <el-dropdown-item command="tencentv3_template">腾讯3.0</el-dropdown-item>
      <el-dropdown-item :command="MEDIAS.KUAISHOU">磁力引擎</el-dropdown-item>
      <el-dropdown-item :command="MEDIAS.BAIDU">百度信息流</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Cookies from 'js-cookie'
import { setLocalInfo, setStoreName, camelcase } from '@/common/js/utils'
import { MEDIAS } from '@/common/js/constants.js'
/**
 * @description: 新建计划下拉项
 */
export default {
  props: {
    buttonType: {
      type: String,
      default: 'primary'
    },
    buttonText: {
      type: String,
      default: '新建计划'
    }
  },
  data() {
    return {
      MEDIAS
    }
  },
  methods: {
    open(cmd) {
      if (cmd === 'toutiao_template') {
        return window.open('/create-plan/toutiao/template', '_blank')
      }

      if (cmd === 'toutiaov3_template') {
        return window.open('/create-plan/toutiaov3/template', '_blank')
      }

      if (cmd === 'tencentv3_template') {
        return window.open('/create-plan/gdt/template', '_blank')
      }

      const account = Cookies.get('ch_user_name')
      const id = Cookies.get('ch_op_id')
      const storeName = setStoreName(cmd)

      setLocalInfo(id, account, String(cmd))
      this.$store.commit(`${camelcase(storeName)}/setMedia`, cmd)
      this.$store.commit(`${camelcase(storeName)}/setOpId`, id)
      this.$store.commit(`${camelcase(storeName)}/setAdmin`, account)
      if (cmd === MEDIAS.TOUTIAO) {
        window.open('/create/toutiaonewlocal/project', '_blank')
      } else {
        window.open(`/create/${storeName}/group`, '_blank')
      }
    }
  }
}
</script>

<style></style>
